<template>
    <div class="request_form">
      <CCard>
        <CCardBody>
            <div class="artpackTypeButtons" v-show="form.department !== ''">
                <center>
                  <CButton size="sm" class="ml-1" :color="form.form_type === 'import' ? 'info' : 'outline-info'" @click="form.form_type = 'import'">Import</CButton>
                  <CButton size="sm" class="ml-1" :color="form.form_type === 'Domestic Coloring' ? 'info' : 'outline-info'" @click="form.form_type = 'Domestic Coloring'">Domestic Coloring</CButton>
                  <CButton size="sm" class="ml-1" :color="form.form_type === 'Component/Tape' ? 'info' : 'outline-info'" @click="form.form_type = 'Component/Tape'">Component/Tape</CButton>
                  <CButton size="sm" class="ml-1" :color="form.form_type === 'Vulcan/DTG' ? 'info' : 'outline-info'" @click="form.form_type = 'Vulcan/DTG'">Vulcan/DTG</CButton>
                </center>
            </div>
            <div class="row" style="margin-top:15px;" v-show="form.form_type !== ''">
                <div class="col-lg-12">
                    <form v-on:submit.prevent="submitForm()" enctype="multipart/form-data" ref="asi_input" name="containerform" id="formContainer" autocomplete="on" class="form-horizontal" role="form">
                    	<input type="hidden" name="userId" :value="this.$store.state.user.id" />
                        <input type="hidden" name="userName" :value="this.$store.state.user.name" />
                        <input type="hidden" name="userPicture" :value="this.$store.state.user.picture" />
                    	<fieldset>
                    		<legend>Info</legend>
                            <!-- <div class="col-sm-12">
                                <account-search v-on:account-found="accountFound"></account-search>
                            </div> -->
                    		<div class="form-group">
                                <label class="control-label col-sm-4" for="csr_name">Customer Name
                                </label>
                                <div class="col-sm-8">
                                    <input v-model="form.customer_name" name="customer_name" type="text" id="customer_name" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4" for="csr_name">Account #
                                </label>
                                <div class="col-sm-8">
                                    <input v-model="form.account_number" name="account_number" type="text" id="account_number" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4" for="csr_name">CC#
                                </label>
                                <div class="col-sm-8">
                                    <input v-model="form.cc_number" name="cc_number" type="text" id="cc_number" class="form-control" />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4" for="csr_name">Log#
                                </label>
                                <div class="col-sm-8">
                                    <input v-model="form.log_number" name="log_number" type="text" id="log_number" class="form-control" />
                                </div>
                            </div>
                    		<div class="form-group" v-show="typeOfRequest === 'new'">
                                <label class="control-label col-sm-4" for="csr_name">CSR
                                </label>
                                <div class="col-sm-8">
                                    <v-select v-if="csr_options !== null" style="height:34px;padding:0;width:100%;" placeholder="Select CSR" v-model="form.csr_name" :options="csr_options" required="true"></v-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4" for="csr_name">For Today's Ship Date
                                </label>
                                <div class="col-sm-8 checkarea2 container">
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.top_priority" type="radio" value="1" required /><span>Yes</span></label>
                                    </div>
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.top_priority" type="radio" value="0" /><span>No</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" v-show="form.form_type === 'Domestic Coloring'">
                                <label class="control-label col-sm-4" for="csr_name">30+ Day Ship Date
                                </label>
                                <div class="col-sm-8 checkarea2 container">
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.thirty_day_ship" type="radio" value="1" /><span>Yes</span></label>
                                    </div>
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.thirty_day_ship" type="radio" value="0" /><span>No</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group" v-show="form.form_type === 'Domestic Coloring'">
                                <label class="control-label col-sm-4" for="csr_name">Tonal?
                                </label>
                                <div class="col-sm-8 checkarea2 container">
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.tonal" type="radio" value="1" /><span>Yes</span></label>
                                    </div>
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.tonal" type="radio" value="0" /><span>No</span></label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4" for="csr_name">Event?
                                </label>
                                <div class="col-sm-8 checkarea2 container">
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.event" type="radio" value="1" /><span>Yes</span></label>
                                    </div>
                                    <div class="col-sm-4">
                                        <label>
                                            <input v-model="form.event" type="radio" value="0" /><span>No</span></label>
                                    </div>
                                </div>
                            </div>
                    	</fieldset>
                        <fieldset v-if="form.form_type === 'component'">
                            <legend>Component Type</legend>
                            <div class="form-group">
                                <label class="control-label col-sm-4" for="component_description">Description
                                </label>
                                <div class="col-sm-8">
                                    <v-select style="text-transform: capitalize;" name="component_description" placeholder="Select Component Type" v-model="form.component_description" required :options="typeOptions"></v-select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="control-label col-sm-4" for="component_type">Type
                                </label>
                                <div class="col-sm-8">
                                    <input type="text" class="form-control" disabled name="component_type" v-model="component_type" required ></input>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset v-if="form.form_type === 'Domestic Coloring' || form.form_type === 'import'">
                            <legend>Tapes</legend>
                            <div id="product1" v-for="tape in form.tapes" class="col-12 float-left">
                                <div class="form-group">
                                    <label class="control-label col-sm-4">Decoration #</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="tape.number">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-4">Position</label>
                                    <div class="col-sm-8">
                                        <!-- <input type="text" class="form-control" v-model="product.position" id="style_color" name="style_color"> -->
                                        <v-select multiple style="width:100%;" required placeholder="Select Position" v-model="tape.position" :options="positionOptions"></v-select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-4">Name</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="tape.name">
                                    </div>
                                </div>
                                <div v-if="tape.position.indexOf('Other') > -1" class="form-group">
                                    <label class="control-label col-sm-4">Other</label>
                                    <div class="col-sm-8">
                                        <input type="text" class="form-control" v-model="tape.extra" />
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label class="control-label col-sm-4">Technique</label>
                                    <div class="col-sm-8">
                                        <v-select v-model="tape.technique" :options="technique_options"></v-select>
                                    </div>
                                </div>
                                <spacer />
                            </div>
                            <div class="adddel text-center" style="width: 100%;float: left;margin-top:15px;">
                                <CButton size="sm" color="success" @click="form.tapes.push({number: '', name: '', position: '', extra: '', stitch_count: '', technique: ''})"><span class="btnText">ADD TAPE</span></CButton>
                                <CButton size="sm" class="ml-2" color="danger" @click="form.tapes.pop()"><span class="btnText">REMOVE TAPE</span></CButton>
                            </div>
                        </fieldset>
                        <fieldset v-if="form.form_type === 'Component/Tape'">
                            <legend>Decorations</legend>
                            <div id="product1" v-for="tape in form.tapes" class="clonedInput1">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <label class="control-label col-sm-4">Position</label>
                                        <div class="col-sm-8">
                                            <!-- <input type="text" class="form-control" v-model="product.position" id="style_color" name="style_color"> -->
                                            <v-select multiple style="width:100%;" required placeholder="Select Position" v-model="tape.position" :options="positionOptions"></v-select>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label col-sm-4">Name</label>
                                        <div class="col-sm-8">
                                            <input type="text" class="form-control" v-model="tape.name">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label col-sm-4">Technique</label>
                                        <div class="col-sm-8">
                                            <v-select v-model="tape.technique" :options="technique_options_component"></v-select>
                                        </div>
                                    </div>
                                </div>
                                <spacer />
                            </div>
                            <div class="adddel text-center" style="width: 100%;float: left;margin-top:15px;">
                                <CButton size="sm" color="success" @click="form.tapes.push({number: '', name: '', position: '', extra: '', stitch_count: '', technique: ''})"><span class="btnText">ADD TAPE</span></CButton>
                                <CButton size="sm" class="ml-2" color="danger" @click="form.tapes.pop()"><span class="btnText">REMOVE TAPE</span></CButton>
                            </div>
                            <!-- <div class="adddel" style="margin-top:15px;">
                                <button type="button" class="glyphicon glyphicon-plus" @click="form.tapes.push({number: '', name: '', position: '', extra: '', stitch_count: '', technique: ''})"><span class="btnText">ADD TAPE</span></button>
                                <button type="button" class="glyphicon glyphicon-minus" @click="form.tapes.pop()"><span class="btnText">REMOVE TAPE</span></button>
                            </div> -->
                        </fieldset>
                        <div class="col-12 float-left">
                            <legend>Comments</legend>
                            <div>
                                <textarea style="width:100%;" v-model="form.comments" rows="7"></textarea>
                            </div>
                        </div>
                        <div class="col-12 float-left">
                            <legend>Attach Reference Art</legend>
                                <div style="width: 100%;float:left;" class="form-group full autoheight">
                                    <reference-art @image-selected="imageSelected"></reference-art>
                                </div>
                        </div>
                        <!-- <fieldset id="uploadWrapper">
                            <legend>Upload</legend>
                            <div class="form-group full autoheight">
                                <h4 class="upload">Upload Image If Needed</h4>
                                <input type="file" name="images[]" class="dropify" data-max-file-size="10M" data-allowed-file-extensions="pdf png jpg jpeg ai zip xls eps bmp emb dst" multiple />
                            </div>
                        </fieldset> -->
                        <div class="form-actions float-left">
                            <div class="col-sm-12">
                                <input type="submit" v-show="typeOfRequest === 'new' && !loading && configureShow()" class="btn btn-primary" tabindex="-1" value="Submit Request"></input>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
          </CCardBody>
        </CCard>
    </div>
</template>
<script>
// import {getCsr, submitForm} from './../config'
import ReferenceArt from './reference_art'
var methods = {}

methods.submitForm = function () {
    this.loading = true
  const postData = {
    form: this.form,
    ref_images: this.refImages
  }
  console.log(postData)
  axios.post(this.$apiAdress + '/api/flow/submitEscape?token=' + localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    this.loading = false
    this.$emit('submitted', this.form)
  }).catch(e => {
    window.Swal.fire({
        type: 'error',
        title: 'Oops!',
        text: 'Looks like something went wrong.'
    })
  })
}

methods.configureShow = function () {
    if (this.form.csr_name) {
        return true
    } else {
        return false
    }
}

// methods.submitForm = function () {
// 	var form = document.querySelector('form')
// 	var request = new XMLHttpRequest()
//     var formData = new FormData(form)
//     var that = this

//             this.loading = true
//             // var comments = new FormData()
//             // console.log(comments)
//             console.log(formData)
//             request.open('post', 'http://workf')
//             formData.append('comments', that.form.comments)
//             formData.append('csr_name', that.form.csr_name.value)
//             formData.append('customer_name', that.form.customer_name)
//             formData.append('account_number', that.form.account_number)
//             formData.append('top_priority', that.form.top_priority)
//             formData.append('thirty_day_ship', parseInt(that.form.thirty_day_ship))
//             formData.append('cc_number', that.form.cc_number)
//             formData.append('log_number', that.form.log_number)
//             formData.append('type', 'escape')
//             formData.append('form_type', that.form.form_type)
//             if (this.form.form_type === 'Domestic Coloring' || this.form.form_type === 'import' || this.form.form_type === 'Component/Tape') {
//             	formData.append('tapes', JSON.stringify(this.form.tapes))
//             	formData.append('component_description', '')
//             	formData.append('component_type', '')
//             } else {
//             	formData.append('tapes', '')
//             	formData.append('component_description', this.form.component_description)
//             	formData.append('component_type', this.component_type)
//             }

//             if (this.refImages !== null) {
//                 if (this.refImages.length) {
//                     formData.append('ref_images', JSON.stringify(this.refImages))
//                     formData.append('ref_number', this.refNumber)
//                     formData.append('ref_type', this.refType)
//                 }

//             }
//             request.send(formData)
//             request.addEventListener("progress", function(evt) {
//                 if (evt.lengthComputable) {
//                     var percentComplete = (evt.loaded / evt.total) * 100
//                     //Do something with upload progress

//                 }
//             }, false)
//             request.addEventListener("load", function(data) {
//                 console.log(data)
//                 if (data.currentTarget.status === 200) {
//                     var response = JSON.parse(data.currentTarget.response)
//                     console.log(response)
//                     that.$router.push('/task/escape/' + response)
//                 } else {
//                     that.loading = false
//                     // that.$router.push('/500')
//                 }
//             })
//     // } else {
//     //     swal('Error!', 'Please choose a csr before submitting the form.', 'error')
//     // }
// }

methods.getCsrs = function () {
    var that = this
    axios.post(this.$apiAdress + '/api/flow/getCsrs?token=' + localStorage.getItem('api_token')).then(response => {
        // if (response.status === 200) {
            this.csr_options = []
            response.data.forEach(function (user) {
                var obj = {
                    value: user.id,
                    label: user.name
                }
                that.csr_options.push(obj)

                if (user.email === that.$store.state.user.email) {
                    that.form.csr_name = obj
                }
            })
        // }
    })
}

methods.imageSelected = function(images, refNumber, type) {
    console.log(refNumber)
    console.log(type)
    this.refImages = images
    this.refNumber = refNumber
    this.refType = type
}

methods.accountFound = function (obj) {
    this.form.account_number = obj.account_number
    this.form.customer_name = obj.account_name
    // this.form.rep_name = obj.rep_name
}

export default {
    name: "EscapeRequest",
    data: function () {
    	return {
            loading: false,
            refNumber: '',
            refType: '',
    		form: {
    			form_type: '',
                type: 'escape',
    			comments: '',
    			component_description: '',
    			csr_name: '',
    			customer_name: '',
				account_number: '',
				cc_number: '',
                log_number: '',
                tonal: 0,
                event: 0,
                top_priority: 0,
                thirty_day_ship: 0,
    			tapes: [{
                    number: '',
                    name: '',
                    position: '',
                    extra: '',
                    stitch_count: '',
                    technique: ''
                }]
    		},
            refImages: null,
    		typeOfRequest: '',
    		csr_options: [],
    		technique_options: ['Applique w Embroidery', 'Embroidery', '3D Embroidery', 'Printed Twill', 'Flocking', '3D Insignia', 'Weathered Patch', 'Micro Heat Transfer', 'Heat Seal', 'Retro Patch', 'Woven Label'],
    		positionOptions: ['Front', 'WRS Left Side', 'WRS Right Side', 'Back', 'Backstrap', 'Other'],
    		typeOptions: ['retro patch', '3D insignia', 'sublimation marrow edge patch', 'woven label marrow edge'],
            technique_options_component: ['3D Insignia', 'Sublimated Retro Patch', 'Rertro Patch', 'Micro Patch', 'Tape Request', 'Woven Label', 'H# Request']
    	}
    },
    components: {
        ReferenceArt
    },
    props: ['newData', 'group'],
    computed: {
        component_type: function () {
            if (this.form.component_description !== '') {
                switch (this.form.component_description) {
                    case 'retro patch':
                        return 'PPE'
                        break
                    case '3D insignia':
                        return 'PPHI'
                        break
                    case 'sublimation marrow edge patch':
                        return 'PPSM'
                        break
                    case 'woven label marrow edge':
                        return 'PPWE'
                        break
                    case 'woven label':
                        return 'PPL'
                        break
                    default:
                        return null
                        break
                }
            } else {
                return ''
            }
        }
    },
    methods: methods,
    mounted: function() {
        console.log(this)
        // if (this.task) {
        //     this.typeOfRequest = 'save'
        //     this.form = this.task
        // } else {
            this.typeOfRequest = 'new'
        // }
        if (this.newData) {
          var obj = {}
          var group = {}
          for (var key in this.newData) {
            obj[key] = this.newData[key]
          }
          for (var key in this.group) {
            group[key] = this.group[key]
          }
          console.log(obj)
          this.form.customer_name = obj.customer_name
          this.form.account_number = obj.customer_number
          this.form.cc_number = group.cc_number
          this.form.log_number = group.as400_log_number
        }
    	this.getCsrs()
    	
    },
    destroyed: function() {

    }
}
</script>
<style lang="scss" scoped>
  .form-group {
    width:50%;
    float:left;
    min-height:40px;

    .v-select {
      width:100%;
    }

    div {
      float:left;
    }
    label {
      float:left;
    }
  }
</style>
